import { useRef } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import FiltersMenu from '../../../components/filters-menu/FiltersMenu';
import PCReimbursementFilters, {
  ReimbursementFilters,
} from '../../../features/accounting/forms/PettyCashReimbursement/PCReimbursementFilters';
import PCReimbursementParams from '../../../features/accounting/forms/PettyCashReimbursement/PCReimbursementParams';
import PCReimbursementReport from '../../../features/accounting/forms/PettyCashReimbursement/PCReimbursementReport';
import PCReimbursementTableContainer from '../../../features/accounting/forms/PettyCashReimbursement/PCReimbursementTableContainer';
import PCReimbursementReportHeader from '../../../features/accounting/forms/PettyCashReimbursement/PCReimburusementReportHeader';

const PettyCashReimburusement = () => {
  const methods = useForm<ReimbursementFilters>();
  const tableRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className="flex flex-column justify-content-center gap-1 pt-4">
      <div className="text-35px font-bold text-center mb-2">
        Petty Cash Reimbursement
      </div>
      <FormProvider {...methods}>
        <div className="mt-5 px-3 flex w-full justify-content-between">
          <FiltersMenu>
            <PCReimbursementFilters />
          </FiltersMenu>
          <PCReimbursementReport elementRef={tableRef} />
        </div>
        <div className="mt-1 printBackground pdfDivFitContent" ref={tableRef}>
          <PCReimbursementReportHeader />
          <PCReimbursementTableContainer />
        </div>
        <PCReimbursementParams />
      </FormProvider>
    </div>
  );
};

export default PettyCashReimburusement;
